import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

interface EmphasizedValueLabelProps {
  labelKey: LangEnum;
  valueName: string;
  value: string;
  params?: Record<string, string | number>;
}

const EmphasizedValueLabel = ({
  labelKey,
  valueName,
  value,
  params,
}: EmphasizedValueLabelProps) => {
  const { formatMessage } = useTranslation();

  return (
    <>
      {formatMessage(
        { id: labelKey },
        {
          ...params,
          [valueName]: (
            <Typography variant="inherit" component="span" sx={{ fontWeight: 'medium' }}>
              {value}
            </Typography>
          ),
        },
      )}
    </>
  );
};

export default EmphasizedValueLabel;
